import React from 'react';

import { IIconProps, TIconType } from '../interface';

const CrowdCellActiveIcon: TIconType = (props?: IIconProps) => {
	return (
		<svg
			fill='none'
			height='24'
			viewBox='0 0 24 24'
			width='24'
			{...props?.innerSvgProps}
		>
			<path
				d='M11.7201 10.5L20 4M11.7201 10.5L3 8.42523M11.7201 10.5V22M20 4L10.9408 2L3 8.42523M20 4V15.3875L11.7201 22M3 8.42523V20L11.7201 22'
				stroke='#2E2E6B'
			/>
			<path
				d='M11.5 10.5L3 8.5V20L11.5 22V10.5Z'
				fill='currentColor'
			/>
		</svg>
	);
};

export default CrowdCellActiveIcon;

